import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from './Components/App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ToastProvider } from 'react-toast-notifications';
import QuestForBlue from './Theme';

import store from './Redux/store';

import 'amphitheatre/dist/index.css';

export let rawURL = 'saberdev.xyz';

if (process.env.REACT_APP_ENV === 'development') {
  rawURL = 'saberdev.xyz';
} else if (process.env.REACT_APP_ENV === 'staging') {
  rawURL = 'saberstaging.xyz';
} else if (process.env.REACT_APP_ENV === 'production') {
  rawURL = 'saberastro.com';
}

axios.defaults.baseURL = `https://${rawURL}`;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastProvider>
        <ThemeProvider theme={QuestForBlue}>
          <App />
        </ThemeProvider>
      </ToastProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
